import { AdminUserResult } from "./client/types/admin"
import { notUndefined } from "./util"

export function getUsername(user: AdminUserResult): string | undefined {
    console.log('user: ', user)
    if (user.email?.length) {
        return user.email
    }

    if (user.postDetails?.compatibleUsername?.length) {
        return user.postDetails.compatibleUsername
    }

    return undefined
}

/**
 * Matches users by any of `email`, `postDetails?.compatibleUsername`, etc.
 * @param instances 
 * @param criteria 
 */
export function matchUsers(arr: AdminUserResult[], search: RegExp) {
    return arr.filter(user => {
        // const map = criteriaToMap(inst)
        // const company = (map.get('company') ?? "").toLowerCase()
        // const cluster = (map.get('cluster') ?? "").toLowerCase()
        // const name = inst.name
  
        const email = user.email?.toLowerCase()
        const username = getUsername(user)?.toLowerCase().replace(/[^a-z]/g, '')
        const firstName = user.firstName?.toLowerCase().replace(/[^a-z]/g, '')
        const lastName = user.lastName?.toLowerCase().replace(/[^a-z]/g, '')
        const stations = (user?.postDetails?.stations ?? []).join(' ')

        if (search.exec(email ?? "") || search.exec(username ?? "") || search.exec(firstName ?? "") || search.exec(lastName ?? "") || search.exec(stations ?? "")) {
            return true
        }
  
        return false
    }).filter(notUndefined)
  }
  
  export function matchUsersByPrefix(arr: AdminUserResult[], search: string) {
    const searchStr = search?.toLowerCase()?.replace(/[^a-z]/g, '')
    if (!searchStr?.length) { return arr }
    const regex = new RegExp(`^${searchStr}`)
    return matchUsers(arr, regex)
  }

  export function matchUsersByPostStation(arr: AdminUserResult[], station: string) {
    const stationLower = station.toLowerCase()

    return arr.filter(user => {
        const stations = new Set(user?.postDetails?.stations?.map(s => s.toLowerCase()) ?? [])
        return stations.has(stationLower)
    })
  }
